import {
  Box,
  Button,
  FieldText,
  FlexBox,
  Modal,
  ModalBody,
  ModalHead,
  SelectionList,
  Text,
} from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useState } from 'react';
import { useWatch } from 'react-hook-form';

import { HookFormSelectionList } from 'components/hookForm';

import { CustomFormField } from '../../../../customForms.types';
import { FormValues } from '../../customFormEditPage.types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function FormPreviewModal({ isOpen, onClose }: Props): JSX.Element {
  const [showSubmitFeedback, setShowSubmitFeedback] = useState(false);
  const values = useWatch<FormValues>();

  const handleClose = () => {
    setShowSubmitFeedback(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      allowEscClose
      allowClickOutside
    >
      <Box width="500px">
        <ModalHead title="Form preview" onClose={handleClose} />

        <ModalBody>
          <Box>
            <PreviewFields
              formFields={(values.formFields ?? []) as CustomFormField[]}
            />

            {showSubmitFeedback ? (
              <FlexBox justifyContent="center" alignItems="center">
                <Text.Paragraph variant="2">
                  {values.feedbackAfterSubmit}
                </Text.Paragraph>
              </FlexBox>
            ) : (
              <Button
                type="button"
                variant="primary"
                style={{ background: '#0A0A0A', width: '100%' }}
                onClick={() => setShowSubmitFeedback(true)}
              >
                {values.submitButtonLabel ?? 'Send'}
              </Button>
            )}
          </Box>
        </ModalBody>
      </Box>
    </Modal>
  );
}

function PreviewFields({ formFields }: { formFields: CustomFormField[] }) {
  return (
    <>
      {formFields.map((field, index): JSX.Element => {
        const key = `${field.type}-${field.title}-${index}`;

        switch (field.type) {
          case 'text':
            return (
              <FieldText
                key={key}
                input={{ name: field.title, onChange: noop, value: '' }}
                type="text"
                label={field.title}
                required={field.required}
                placeholder={field.placeholder}
              />
            );

          case 'select':
            return (
              <HookFormSelectionList
                key={key}
                name={field.title}
                label={field.title}
                componentProps={{ getItemTitleByValue: (item) => item }}
              >
                {field.options?.map((option, index) => (
                  <SelectionList.Item
                    key={index}
                    value={`${option.value}-${index}`}
                  >
                    {option.value}
                  </SelectionList.Item>
                ))}
              </HookFormSelectionList>
            );
        }
      })}
    </>
  );
}
